<template>
    <div>
        <Header :logged="logged" :home="false" />
        <div>
            <div class="atendimento-page">
                <div id="atendimento">
                    <h1>Mande-nos uma mensagem</h1>
                    <b-form @submit="onSubmit" id="atendimento-subscribe">
                        <b-form-group>
                            <label label-for="nome">Nome:</label>
                            <b-form-input type="text" id="nome" v-model="nome" placeholder="Seu nome"
                                required></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label label-for="email">Email:</label>
                            <b-form-input type="text" id="email" v-model="email" placeholder="email@exemplo.com.br"
                                required></b-form-input>
                        </b-form-group>
                        <b-form-group>
                            <label label-for="telefone">Telefone:</label>
                            <b-form-input :mask="['(##) ####-####', '(##) #####-####']" type="text" id="telefone" v-model="telefone" placeholder="(XX) X XXXX-XXXX"
                            required></b-form-input>
                        </b-form-group>
                        <b-form-group class="atendimento-select-group">
                            <label label-for="uf">UF:</label>
                            <b-form-select v-model="uf" ref="ufSelect" :options="estados" class="atendimento-select" id="uf">
                                <template #first>
                                    <b-form-select-option :value="null" disabled>Selecione um Estado</b-form-select-option>
                                </template>
                            </b-form-select>
                            <div class="atendimento-select-arrow"></div>
                        </b-form-group>
                        <b-form-group>
                            <label label-for="mensagem">Mensagem</label>
                            <b-form-textarea id="mensagem" v-model="mensagem" size="lg" no-resize rows="7"
                                required></b-form-textarea>
                        </b-form-group>
                        <b-alert :show="mensagem_enviada" fade variant="success">Contato realizado</b-alert>
                        <b-alert :show="!mensagem_enviada && mensagem_enviada != null" fade variant="danger">Não foi
                            possivel realizar o contato</b-alert>
                        <b-button type="submit" @click="enviar" block v-if="!mensagem_enviada && !loading">Enviar</b-button>
                        <b-button class="loading" v-if="loading">
                            <b-spinner variant="primary" label="Spinning"></b-spinner>
                        </b-button>
                    </b-form>
                    <div class="atendimento-nossos-contatos">
                        <h2>Nossos contatos</h2>
                        <p><b>Contato:</b> (11) 3112 0698</p>
                        <p><b>E-mail:</b> consultaprotesto@cartoriosdeprotesto.org.br</p>
                    </div>
                </div>
            </div>
        </div>

        <footersite class="d-none d-xl-block" />
        <footersitemobile class="d-block d-xl-none" />
    </div>
</template>

<script>
import Header from '../components/Header';
import footersite from '../components/footersite';
import footersitemobile from '../components/footersite/index_mobile';
import { TheMask } from "vue-the-mask";
import Serv from "../services";
import API from "../services/api";
import Estados from "../services/estados"

export default {
    components: {
        TheMask,
        Header,
        footersite,
        footersitemobile
    },
    data() {
        return {
            logged: false,
            nome: null,
            email: null,
            telefone: null,
            telefoneMask:['(##) ####-####', '(##) #####-####'],
            uf: null,
            mensagem: null,
            estados:[],
            loading: null,
            mensagem_enviada: null,
        }
    },
    methods: {
        onSubmit: function () {

        },
        validar() {
            let self = this;
            let campos = [
                "nome",
                "email",
                "telefone",
                "mensagem",
                "uf"
            ];
            let erros = 0;

            // verifica campos
            campos.forEach(campo => {
                erros += self.isInvalid(campo, self[campo]) ? 1 : 0;
            });
            //email
            const d = { ...this.$data };
            if (!Serv.validarEmail(d.email)) {
                document.getElementById("email").classList.add("is-invalid");
                return false;
            }
            return erros > 0 ? false : true;
        },
        enviar() {
            let self = this;
            if (this.validar()) {
                const d = { ...this.$data };
                const dados = {
                    nome: d.nome,
                    email: d.email,
                    telefone: d.telefone,
                    mensagem: d.mensagem,
                    uf: d.uf
                };
                this.loading = true;
                API.post("contato", dados).then(res => {
                    if (res.data.enviada) {
                        self.loading = false;
                        self.mensagem_enviada = true;
                    } else {
                        self.loading = false;
                        self.mensagem_enviada = false;
                    }
                }).catch(() => {
                    this.loading = false;
                    this.mensagem_enviada = false;
                })

            }
        },
        isInvalid(field, value) {
            if (field == 'mensagem') {
                if (!value) document.getElementById(field).classList.add("isInvalidMensagem");
                else document.getElementById(field).classList.remove("isInvalidMensagem");
            }
            if (!value) document.getElementById(field).classList.add("is-invalid");
            else document.getElementById(field).classList.remove("is-invalid");
            return value ? false : true;
        }
    },
    mounted() {
        this.$root.isLogged().then(() => {
            this.logged = true
        }).catch(() => {
            this.logged = false
        });
        this.estados = Estados.map(estado => ({
            text: estado.Nome,
            value: estado.Sigla
        }));
    },
}
</script>

<style scoped>
.atendimento-page {
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    overflow: hidden;
}

#atendimento {
    margin: 0 auto;
    margin: 0px 0 37px 0;
    width: 100%;
    display: flex;
    align-items: center;
    flex-flow: column;
    padding-top: 60px;
    overflow: auto;
    padding-bottom: 67px;
}

#atendimento h1 {
    text-align: center;
    font: normal normal 100 50px/55px 'Kanit', sans-serif;
    letter-spacing: -1%;
    color: var(--secondary-color);
    margin-bottom: 28px;
}

#atendimento #atendimento-subscribe {
    width: 963px;
    margin-bottom: 89px;
}

#atendimento #atendimento-subscribe label {
    text-align: left !important;
    font: normal normal 200 16px/20px 'Kanit' !important;
    letter-spacing: -1% !important;
    color: var(--secondary-color) !important;
    margin-bottom: 10px !important;
    margin-left: 20px;
}
#atendimento #atendimento-subscribe .atendimento-select-group {
    position: relative;
}
#atendimento #atendimento-subscribe .atendimento-select-arrow {
    border-right: 5px solid var(--secondary-color);
    border-bottom: 5px solid var(--secondary-color);
    border-left: 5px solid transparent;
    border-top: 5px solid transparent;
    transform: rotate(45deg);
    width: 9px;
    height: 9px;
    position: absolute;
    cursor: pointer;
    right: 14px;
    top: 44px;
}
#atendimento #atendimento-subscribe input,
#atendimento #atendimento-subscribe textarea,
#atendimento #atendimento-subscribe select,
#atendimento #atendimento-subscribe option {
    text-align: left;
    font: normal normal 200 16px/20px 'Kanit', sans-serif;
    letter-spacing: -1%;
    width: 100%;
    background: #F1F1F1 0% 0% no-repeat padding-box;
    border: 1px solid #FFFFFF;
    border-radius: 5px;
    height: 44px;
    padding-left: 20px;
    border-radius: 42px;
}

#atendimento #atendimento-subscribe textarea{
    height: fit-content;
    padding-top: 20px;
}
#atendimento #atendimento-subscribe input::placeholder,
#atendimento #atendimento-subscribe textarea::placeholder {
    color: var(--secondary-color);
}

#atendimento #atendimento-subscribe input {
    margin-bottom: 17px;
}

#atendimento #atendimento-subscribe textarea {
    margin-bottom: 25px;
}

#atendimento #atendimento-subscribe button {
    /* width: 150px; */
    height: 49px;
    background: var(--primary-color) 0% 0% no-repeat padding-box;
    border: none;
    border-radius: 40px;
    text-align: center;
    font: normal normal 400 20px/20px 'Kanit', sans-serif;
    letter-spacing: -1%;
    color: #FFFFFF;
    padding:0 30px;
    display: flex;
    align-items: center;
    width: fit-content;
}

#atendimento #atendimento-subscribe button.loading {
    background: #FFFFFF 0% 0% no-repeat padding-box;
}

#atendimento #atendimento-subscribe button span.spinner-border {
    color: #597EB5 !important;
    margin-top: -4px;
}

#atendimento h2 {
    text-align: center;
    font: normal normal 600 20px/37px 'Kanit', sans-serif;
    letter-spacing: -1%;
    color: var(--secondary-color);
    margin-bottom: 30px;
}

#atendimento p {
    text-align: center;
    font: normal normal 200 15px/20px 'Kanit', sans-serif;
    letter-spacing: -1%;
    color: var(--secondary-color);
    margin-bottom: 11px;
}

#mensagem::-webkit-scrollbar {
    display: none;
}

#atendimento #atendimento-subscribe .alert.alert-warning,
#atendimento #atendimento-subscribe .alert.alert-danger,
#atendimento #atendimento-subscribe .alert.alert-success {
    max-height: 49px;
    padding: 15px 17px;
    border-radius: 5px;
    font: normal normal bold 15px/20px 'Kanit', sans-serif;
    letter-spacing: 0px;
    text-align: start !important;
}

#atendimento #atendimento-subscribe .alert.alert-warning {
    background: #F8F5CB 0% 0% no-repeat padding-box;
    color: #706927;
}

#atendimento #atendimento-subscribe .alert.alert-danger {
    background: #F8CBCB 0% 0% no-repeat padding-box;
    color: #702727;
}

#atendimento #atendimento-subscribe .alert.alert-success {
    background: #CBF8D8 0% 0% no-repeat padding-box;
    color: #27703C;
}

@media (max-width:1199px) {
    #atendimento {
        overflow: hidden;
        height: fit-content;
        padding: 20px;
        margin-bottom: 70px;
    }

    #atendimento #atendimento-subscribe {
        width: 100%;
    }

    #atendimento #atendimento-subscribe button {
        width: 100%;
    }

    .atendimento-page {
        height: fit-content;
    }
}</style>